
import { createDotPattern, drawJeans, drawGenericFace } from "../utils";

const SKIN_COLOR = "#ffdbac";

export const drawStyle0 = (ctx: CanvasRenderingContext2D) => {
  // Pants: White Skinny
  drawJeans(ctx, "#fdfefe", "#bdc3c7");
  // Shoes: White
  ctx.fillStyle = "#fff"; ctx.fillRect(-12, -5, 10, 5); ctx.fillRect(4, -5, 10, 5);
  
  // Top: Yellow Shirt
  ctx.fillStyle = "#f1c40f";
  ctx.fillRect(-16, -150, 32, 65); // Torso
  // Sleeves
  ctx.save(); ctx.translate(-16, -145); ctx.rotate(0.1); ctx.fillRect(-10, 0, 12, 50); ctx.restore();
  ctx.save(); ctx.translate(16, -145); ctx.rotate(-0.1); ctx.fillRect(-2, 0, 12, 50); ctx.restore();
  // Detail: Buttons
  ctx.fillStyle = "#fff";
  for(let i=0; i<3; i++) ctx.beginPath(), ctx.arc(0, -135 + i*15, 2, 0, Math.PI*2), ctx.fill();

  drawGenericFace(ctx, SKIN_COLOR);
  
  // Hair: Pink, Long
  ctx.fillStyle = "#e91e63";
  ctx.beginPath(); ctx.arc(0, -35, 16, Math.PI, 0); ctx.fill(); // Top
  ctx.beginPath(); ctx.moveTo(-16, -35); ctx.lineTo(-18, -10); ctx.lineTo(-10, -5); ctx.lineTo(-10, -35); ctx.fill(); // Left
  ctx.beginPath(); ctx.moveTo(16, -35); ctx.lineTo(18, -10); ctx.lineTo(10, -5); ctx.lineTo(10, -35); ctx.fill(); // Right
};

export const drawStyle1 = (ctx: CanvasRenderingContext2D) => {
  // Pants: Purple
  drawJeans(ctx, "#8e44ad", "#6c3483");
  // Shoes: Black
  ctx.fillStyle = "#111"; ctx.fillRect(-12, -5, 10, 5); ctx.fillRect(4, -5, 10, 5);

  // Top: Pink Sweater
  ctx.fillStyle = "#ff69b4";
  // Texture (Argyleish dots)
  const pat = ctx.createPattern(createDotPattern("#ff1493"), "repeat");
  ctx.fillRect(-18, -150, 36, 65);
  if (pat) { ctx.fillStyle = pat; ctx.globalAlpha=0.3; ctx.fillRect(-18, -150, 36, 65); ctx.globalAlpha=1.0; }
  
  // Sleeves
  ctx.fillStyle = "#ff69b4";
  ctx.save(); ctx.translate(-18, -145); ctx.rotate(0.2); ctx.fillRect(-10, 0, 14, 50); ctx.restore();
  ctx.save(); ctx.translate(18, -145); ctx.rotate(-0.2); ctx.fillRect(-4, 0, 14, 50); ctx.restore();
  // Collar
  ctx.fillStyle = "#87ceeb"; // Blue shirt under
  ctx.beginPath(); ctx.moveTo(-10, -150); ctx.lineTo(10, -150); ctx.lineTo(0, -140); ctx.fill();

  drawGenericFace(ctx, SKIN_COLOR);

  // Hair: Blue Bowl
  ctx.fillStyle = "#3498db";
  ctx.beginPath(); ctx.arc(0, -32, 14, Math.PI, 0); ctx.lineTo(14, -25); ctx.quadraticCurveTo(0, -20, -14, -25); ctx.fill();
  
  // Hat: Yellow Beret
  ctx.fillStyle = "#f1c40f";
  ctx.beginPath(); ctx.ellipse(5, -45, 18, 10, -0.2, 0, Math.PI*2); ctx.fill();
};

export const drawStyle2 = (ctx: CanvasRenderingContext2D) => {
  // Pants: Light Blue Jeans
  drawJeans(ctx, "#85c1e9", "#5dade2");
  // Shoes: White
  ctx.fillStyle = "#fff"; ctx.fillRect(-12, -5, 10, 5); ctx.fillRect(4, -5, 10, 5);

  // Top: Pink Undershirt
  ctx.fillStyle = "#ffb6c1";
  ctx.fillRect(-14, -150, 28, 60);

  // Top: White Grid Shirt (Open)
  ctx.fillStyle = "#fff";
  ctx.fillRect(-18, -150, 12, 65); // Left panel
  ctx.fillRect(6, -150, 12, 65); // Right panel
  // Grid Lines
  ctx.strokeStyle = "#ccc"; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(-18, -140); ctx.lineTo(-6, -140); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(-18, -130); ctx.lineTo(-6, -130); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(6, -140); ctx.lineTo(18, -140); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(6, -130); ctx.lineTo(18, -130); ctx.stroke();
  
  // Sleeves (Rolled up)
  ctx.fillStyle = "#fff";
  ctx.save(); ctx.translate(-18, -145); ctx.rotate(0.05); ctx.fillRect(-10, 0, 14, 30); ctx.restore();
  ctx.save(); ctx.translate(18, -145); ctx.rotate(-0.05); ctx.fillRect(-4, 0, 14, 30); ctx.restore();
  // Arms
  ctx.fillStyle = SKIN_COLOR;
  ctx.save(); ctx.translate(-22, -115); ctx.rotate(0.1); ctx.fillRect(0, 0, 10, 30); ctx.restore();
  ctx.save(); ctx.translate(18, -115); ctx.rotate(-0.1); ctx.fillRect(0, 0, 10, 30); ctx.restore();

  drawGenericFace(ctx, SKIN_COLOR);

  // Hair: Black, Parted
  ctx.fillStyle = "#111";
  ctx.beginPath(); ctx.arc(0, -35, 15, Math.PI, 0); ctx.fill();
  ctx.beginPath(); ctx.moveTo(0, -40); ctx.quadraticCurveTo(-10, -30, -15, -25); ctx.lineTo(-12, -15); ctx.lineTo(0, -35); ctx.fill();
  ctx.beginPath(); ctx.moveTo(0, -40); ctx.quadraticCurveTo(10, -30, 15, -25); ctx.lineTo(12, -15); ctx.lineTo(0, -35); ctx.fill();
};

export const drawStyle3 = (ctx: CanvasRenderingContext2D) => {
  // Pants: Dark Blue Jeans
  drawJeans(ctx, "#2e86c1", "#1b4f72");
  // Shoes
  ctx.fillStyle = "#333"; ctx.fillRect(-12, -5, 10, 5); ctx.fillRect(4, -5, 10, 5);

  // Top: Green Floral
  ctx.fillStyle = "#1abc9c";
  ctx.fillRect(-18, -150, 36, 60);
  // Flowers
  ctx.fillStyle = "#e74c3c";
  for(let i=0; i<5; i++) {
    ctx.beginPath(); ctx.arc(-10 + (i%2)*20, -140 + i*10, 4, 0, Math.PI*2); ctx.fill();
  }
  
  // Sleeves
  ctx.fillStyle = "#1abc9c";
  ctx.save(); ctx.translate(-18, -145); ctx.rotate(0.1); ctx.fillRect(-10, 0, 14, 30); ctx.restore();
  ctx.save(); ctx.translate(18, -145); ctx.rotate(-0.1); ctx.fillRect(-4, 0, 14, 30); ctx.restore();

  drawGenericFace(ctx, SKIN_COLOR);

  // Hair: Reddish
  ctx.fillStyle = "#c0392b";
  ctx.beginPath(); ctx.arc(0, -32, 14, 0, Math.PI*2); ctx.fill();

  // Hat: Yellow Beanie
  ctx.fillStyle = "#f4d03f";
  ctx.beginPath(); ctx.ellipse(0, -42, 15, 12, 0, Math.PI, 0); ctx.fill();
  ctx.fillStyle = "#f1c40f"; // Rim
  ctx.fillRect(-15, -42, 30, 8);
};

export const drawStyle4 = (ctx: CanvasRenderingContext2D) => {
  // Pants: Light Jeans
  drawJeans(ctx, "#aed6f1", "#85c1e9");
  // Shoes
  ctx.fillStyle = "#fff"; ctx.fillRect(-12, -5, 10, 5); ctx.fillRect(4, -5, 10, 5);

  // Top: Yellow Long Sleeve
  ctx.fillStyle = "#f1c40f";
  ctx.fillRect(-18, -150, 36, 65);
  ctx.save(); ctx.translate(-18, -145); ctx.rotate(0.1); ctx.fillRect(-10, 0, 12, 50); ctx.restore();
  ctx.save(); ctx.translate(18, -145); ctx.rotate(-0.1); ctx.fillRect(-2, 0, 12, 50); ctx.restore();

  // Vest: Purple V-Neck
  ctx.fillStyle = "#8e44ad";
  ctx.beginPath();
  ctx.moveTo(-18, -150); ctx.lineTo(-10, -150); ctx.lineTo(0, -120); ctx.lineTo(10, -150); ctx.lineTo(18, -150);
  ctx.lineTo(18, -85); ctx.lineTo(-18, -85); 
  ctx.fill();

  drawGenericFace(ctx, SKIN_COLOR);

  // Hair: Silver covering eyes
  ctx.fillStyle = "#bdc3c7";
  ctx.beginPath(); ctx.arc(0, -35, 16, Math.PI, 0); ctx.fill(); // Top
  // Bangs covering eyes
  ctx.beginPath(); 
  ctx.moveTo(-16, -35); 
  ctx.quadraticCurveTo(-10, -10, 0, -15);
  ctx.quadraticCurveTo(10, -10, 16, -35);
  ctx.lineTo(16, -40); ctx.lineTo(-16, -40);
  ctx.fill();
};

export const drawPracticeDummy = (ctx: CanvasRenderingContext2D) => {
  // Crash Test Dummy
  const DUMMY_YELLOW = "#fbbf24";
  
  // Legs
  ctx.fillStyle = DUMMY_YELLOW;
  ctx.fillRect(-12, -80, 10, 80);
  ctx.fillRect(2, -80, 10, 80);
  
  // Torso
  ctx.fillStyle = DUMMY_YELLOW;
  ctx.fillRect(-18, -150, 36, 70);
  
  // Arms
  ctx.fillRect(-28, -150, 10, 60);
  ctx.fillRect(18, -150, 10, 60);
  
  // Chest Marker (Black/Yellow Check)
  ctx.save();
  ctx.translate(0, -115);
  ctx.fillStyle = "#000";
  ctx.beginPath(); ctx.arc(0, 0, 12, 0, Math.PI*2); ctx.fill();
  ctx.fillStyle = DUMMY_YELLOW;
  ctx.beginPath(); ctx.moveTo(0,0); ctx.arc(0, 0, 12, 0, Math.PI/2); ctx.lineTo(0,0); ctx.fill();
  ctx.beginPath(); ctx.moveTo(0,0); ctx.arc(0, 0, 12, Math.PI, Math.PI*1.5); ctx.lineTo(0,0); ctx.fill();
  ctx.restore();

  // Head
  ctx.fillStyle = DUMMY_YELLOW;
  ctx.beginPath(); ctx.ellipse(0, -165, 16, 20, 0, 0, Math.PI*2); ctx.fill();
  
  // Face Marker
  ctx.save();
  ctx.translate(0, -165);
  ctx.fillStyle = "#000";
  ctx.beginPath(); ctx.arc(0, 0, 10, 0, Math.PI*2); ctx.fill();
  ctx.fillStyle = DUMMY_YELLOW;
  ctx.beginPath(); ctx.moveTo(0,0); ctx.arc(0, 0, 10, 0, Math.PI/2); ctx.lineTo(0,0); ctx.fill();
  ctx.beginPath(); ctx.moveTo(0,0); ctx.arc(0, 0, 10, Math.PI, Math.PI*1.5); ctx.lineTo(0,0); ctx.fill();
  ctx.restore();
};
